/**
*
* MessageStats
*
*/

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage, useIntl } from 'react-intl';
import { ListGroup, Modal } from 'react-bootstrap';
import UserAvatar from 'components/user/UserAvatar/index.jsx';
import LimitHeight from 'components/layout/LimitHeight/index.js';
import IconButton from 'components/interaction/IconButton/index.jsx';
import messages from '../messages.js';

function MessageStats(props) {
  const { stats, participants, className } = props;
  const intl = useIntl();
  const [show, setShow] = useState(false);
  if (!stats) {
    return null;
  }
  const { seen, seenByAll, unseen } = stats;
  const color = seenByAll ? 'text-success' : 'text-muted';
  const classList = classNames([className, color, 'd-inline-flex align-items-baseline']);
  const iconClass = classNames(['ss-view fs-4 me-2 lower-1', color]);

  function participantsList(message, idList) {
    if (idList.length === 0) {
      return null;
    }
    return (
      <>
        <ListGroup.Item className="shaded text-primary">
          <FormattedMessage {...message} />
        </ListGroup.Item>
        {idList.map((id) => (
          <ListGroup.Item key={id} className="d-flex">
            <UserAvatar user={participants[id]} bsSize="medium" withRole />
            {participants[id].deleted && (
              <span className="text-muted ms-3 mt-1">{`(${intl.formatMessage(messages.deleted)})`}</span>
            )}
          </ListGroup.Item>
        ))}
      </>
    );
  }
  return (
    <>
      <IconButton size="sm" className={classList} variant="link" icon={iconClass} onClick={() => setShow(true)}>
        {seen.length}
      </IconButton>
      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header className="border-bottom-0" closeButton>
          <Modal.Title><FormattedMessage {...messages.participantsSeenMessage} values={{ count: seen.length }} /></Modal.Title>
        </Modal.Header>
        <div className="text-muted text-center p-4 pt-1">
          <FormattedMessage {...messages.viewedByTeachersOnly} />
        </div>
        <LimitHeight as={ListGroup} className="mb-2" margin="120px">
          {participantsList(messages.messageSeenBy, seen)}
          {participantsList(messages.messageNotSeenBy, unseen)}
        </LimitHeight>
      </Modal>
    </>
  );
}

MessageStats.propTypes = {
  className: PropTypes.string,
  stats: PropTypes.object,
  participants: PropTypes.object.isRequired,
};

export default MessageStats;
